Ext.define('SA.view.RecentList', {
    alias: 'widget.recent-list',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-recent-list',
    checkMarkTooltip: 'Shown in the current view',
    floating: true,
    focusIndex: 0,
    plugins: ['close-on-click-outside', 'sa-arrow'],

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-recent-list-header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-recent-list-title',
                    itemId: 'title'
                }, {
                    xtype: 'close-button',
                    closeAction: 'hide'
                }
            ]
        }, {
            xtype: 'component',
            autoEl: {role: 'menu', tag: 'ul'},
            cls: 'sa-recent-list-wrap',
            itemId: 'list',

            tpl: [
                '<tpl for=".">',
                    '<li data-id="{id:htmlEncode}" class="sa-recent-list-item',
                        '<tpl if="selected">',
                            ' sa-recent-list-item-selected',
                        '</tpl>',
                        '<tpl if="unselectable">',
                            ' sa-recent-list-item-unselectable-location',
                        '</tpl>',
                    '" role="presentation">',
                        '<button class="sa-recent-list-item-body" role="menuitemcheckbox" tabindex="-1"',
                              ' aria-checked="<tpl if="selected">true<tpl else>false</tpl>"',
                            '>',
                            '<tpl if="values.clicked || values.isCombination || values.isRadius">',
                                '<span class="sa-recent-list-item-location-icon-wrap">',
                                    '<svg class="sa-recent-list-item-location-icon">',
                                        '<tpl if="clicked">',
                                            '<use href="#sa-icon-clicked-location"></use>',
                                        '<tpl elseif="isCombination">',
                                            '<use href="#sa-icon-combination-location"></use>',
                                        '<tpl else>',
                                            '<use href="#sa-icon-radius-location"></use>',
                                        '</tpl>',
                                    '</svg>',
                                '</span>',
                            '</tpl>',
                            '<span class="sa-recent-list-item-name">{text}</span>',
                            '<span class="sa-recent-list-item-check-wrap" title="{checkMarkTooltip}">',
                                '<svg class="sa-recent-list-item-check">',
                                    '<use href="#sa-icon-check-mark"></use>',
                                '</svg>',
                            '</span>',
                        '</button>',
                        '<button aria-label="options menu" class="sa-recent-list-item-button" tabindex="-1">',
                            '<div class="sa-recent-list-item-button-dot"></div>',
                            '<div class="sa-recent-list-item-button-dot"></div>',
                            '<div class="sa-recent-list-item-button-dot"></div>',
                        '</button>',
                    '</li>',
                '</tpl>'
            ]
        }
    ],

    initComponent() {
        var source = this.source;

        this.callParent();

        this.titleCmp = this.down('#title');
        this.listCmp = this.down('#list');

        this.setSelected(this.selected || []);

        if (this.title) {
            this.setTitle(this.title);
        }

        if (source) {
            this.source = null;
            this.setSource(source);
        }

        if (this.track) {
            SA.view.menu.MenuVisibilityTracker.track(this);
        }
    },

    initEvents() {
        this.callParent();

        this.mon(SA.Viewport, 'resize', this.updateHeight, this);
        this.on('show', this.focusFirstItem, this);

        this.el.on({
            delegate: '.sa-recent-list-item-body',
            scope: this,

            click: this.onItemClick,
            mouseout: this.onItemMouseOut,
            mouseover: this.onItemMouseOver
        });

        this.el.on({
            delegate: '.sa-recent-list-item-button',
            scope: this,

            click: this.onItemButtonClick,
            mouseout: this.onItemButtonMouseOut,
            mouseover: this.onItemButtonMouseOver
        });
    },

    focusFirstItem() {
        var list = this.down('#list'),
            firstItem = list.el.down('.sa-recent-list-item:first .sa-recent-list-item-body');

        if (firstItem) {
            firstItem.el.dom.focus();
        }
    },

    getFilteredItems(source) {
        var items;

        if (!source) {
            return [];
        }

        items = this.getAllData(source).filter(item => item != null && item !== false);

        if (this.filter) {
            items = items.filter(this.filter, this);
        }

        return items;
    },

    getItemHash(item) {
        return item.text;
    },

    getItemsData(source) {
        var newItems = this.getFilteredItems(source);

        newItems = newItems.map(this.dataToItem, this);

        return newItems;
    },

    getRefOwner() {
        return this.pickerOwner;
    },

    isEmpty(source) {
        return this.getFilteredItems(source).length === 0;
    },

    onHide() {
        this.callParent(arguments);

        this.refresh();
        this.focusIndex = 0;

        Ext.getDoc().un('keydown', this.onKeyDown, this);
    },

    onKeyDown(ev) {
        var key = ev.getKey(),
            items = this.el.query('.sa-recent-list-item-body'),
            selectItem = (index) => {
              this.focusIndex = index;
              items[this.focusIndex].focus();
            };

        switch (key) {
            case ev.ESC:
              this.hide();
              break;

            case ev.SPACE:
              if (document.activeElement.classList.contains('sa-recent-list-item-button')) {
                  this.onItemButtonClick(ev, document.activeElement);
              }
              break;

            case ev.LEFT:
              items[this.focusIndex].focus();
              break;

            case ev.RIGHT:
              items[this.focusIndex].nextElementSibling.focus();
              break;

            case ev.DOWN:
              selectItem((this.focusIndex + 1 >= items.length) ? 0 : this.focusIndex + 1);
              break;

            case ev.UP:
              selectItem((this.focusIndex - 1 < 0) ? items.length - 1 : this.focusIndex - 1);
              break;
        }

    },

    onItemButtonClick(ev, target) {
        var { el, focusIndex } = this,
            id = ev.getTarget('.sa-recent-list-item').getAttribute('data-id'),
            menu = this.lastMenu;

        if (menu && this.lastMenuId === id && menu.wasRecentlyVisible()) {
            return;
        }

        Ext.destroy(menu);

        Ext.fly(target).addCls('sa-recent-list-item-button-active');

        this.lastMenuId = id;

        menu = this.lastMenu = Ext.widget(Object.assign({
            xtype: 'menu',
            cls: 'sa-menu-compact',
            getRefOwner: () => this,
            track: true,

            plugins: [{
                ptype: 'sa-arrow',
                target
            }]
        }, this.getMenuConfig(id)));

        menu.mon(this.listCmp.el, 'scroll', menu.hide, menu, {single: true});
        menu.mon(SA.Viewport, 'resize', menu.hide, menu, {single: true});

        menu.on('hide', function() {
            var items = el.query('.sa-recent-list-item-body');

            Ext.fly(target).removeCls('sa-recent-list-item-button-active');

            items[focusIndex].focus();
        });

        menu.showBy(target, 'tl-tr?', [7, 0]);

        menu.el.query('.x-menu-item a').forEach((el) => {
            el.setAttribute('role', 'menuitem');
        });
    },

    onItemButtonMouseOut(ev, target) {
        Ext.fly(target).removeCls('sa-recent-list-item-button-hover');
    },

    onItemButtonMouseOver(ev, target) {
        Ext.fly(target).addCls('sa-recent-list-item-button-hover');
    },

    onItemClick(ev) {
        var el = ev.getTarget('.sa-recent-list-item'),
            id = el.getAttribute('data-id');

        if (Ext.fly(el).hasCls('sa-recent-list-item-selected-animation')) {
            Ext.fly(el).removeCls('sa-recent-list-item-selected-animation');

            Ext.fly(el).getStyle('background-color');
        }

        Ext.fly(el).addCls('sa-recent-list-item-selected-animation');

        this.fireEvent('select', this, id);
    },

    onItemMouseOut(ev) {
        Ext.fly(ev.getTarget('.sa-recent-list-item')).removeCls('sa-recent-list-item-hover');
    },

    onItemMouseOver(ev) {
        Ext.fly(ev.getTarget('.sa-recent-list-item')).addCls('sa-recent-list-item-hover');
    },

    onShow() {
        this.callParent(arguments);

        Ext.getDoc().on('keydown', this.onKeyDown, this);
    },

    refresh() {
        var newItems = this.getItemsData(this.source),
            oldItems = this.oldItems,
            selected = this.selected,
            oldItemsMap, elSpecs, itemEls, transformedEls;

        if (this.isVisible()) {
            if (oldItems && oldItems.length === newItems.length) {
                oldItemsMap = {};

                oldItems.forEach(item => {
                    oldItemsMap[item.id] = item;
                });

                if (newItems.every(item => {
                    var oldItem = oldItemsMap[item.id];

                    return oldItem && this.getItemHash(oldItem) === this.getItemHash(item);
                })) {
                    return;
                }
            }

            elSpecs = {};

            this.el.query('.sa-recent-list-item').forEach(el => {
                elSpecs[el.getAttribute('data-id')] = {
                    offset: el.offsetTop
                };
            });
        }

        newItems.forEach(item => {
            item.checkMarkTooltip = this.checkMarkTooltip;
            item.selected = selected[item.id];
        });

        this.listCmp.update(newItems);

        this.updateHeight();

        this.oldItems = newItems;

        if (elSpecs) {
            itemEls = this.el.query('.sa-recent-list-item');

            transformedEls = [];

            itemEls.forEach(el => {
                var id = el.getAttribute('data-id'),
                    elSpec = elSpecs[id],
                    newOffset, oldOffset;

                if (elSpec) {
                    newOffset = el.offsetTop;
                    oldOffset = elSpec.offset;

                    if (newOffset !== oldOffset) {
                        elSpec.offsetDelta = oldOffset - newOffset;

                        transformedEls.push(el);
                    }
                }
            });

            transformedEls.forEach(el => {
                var id = el.getAttribute('data-id'),
                    oldElSpec = elSpecs[id];

                Ext.fly(el).setStyle('transform', 'translate(0, ' + oldElSpec.offsetDelta + 'px)');
            });

            transformedEls.forEach(el => {
                Ext.fly(el).getHeight();
            });

            transformedEls.forEach(el => {
                Ext.fly(el).setStyle('transition', '250ms transform');
                Ext.fly(el).setStyle('transform', 'translate(0, 0)');
            });
        }
    },

    setFilter(filter) {
        this.filter = filter;

        this.refresh();
    },

    setSelected(selected) {
        var oldSelected = this.selected,
            newSelected = this.selected = {},
            el = this.el;

        selected.forEach(item => newSelected[item] = true);

        if (!Ext.Object.equals(oldSelected, newSelected)) {
            if (el) {
                el.query('.sa-recent-list-item').forEach(el => {
                    var isSelected = !!newSelected[el.getAttribute('data-id')];

                    el.querySelector('.sa-recent-list-item-body').setAttribute('aria-checked', isSelected);
                    Ext.fly(el).ifCls(isSelected, 'sa-recent-list-item-selected');
                });
            }
            else {
                this.refresh();
            }
        }
    },

    setSource(source) {
        var oldSource = this.source;

        if (source === oldSource) {
            return;
        }

        this.mun(oldSource, 'change', this.refresh, this);

        this.mon(source, 'change', this.refresh, this);

        this.source = source;

        this.refresh();
    },

    setTitle(title) {
        this.titleCmp.update(title);
    },

    showBy() {
        this.callParent(arguments);

        this.updateHeight();
    },

    updateHeight() {
        var maxHeight, dom, scrollTop;

        if (!this.isVisible()) {
            return;
        }

        dom = this.listCmp.el.dom;
        scrollTop = dom.scrollTop;

        maxHeight = Ext.dom.Element.getViewportHeight() - this.getY() - 30;

        this.setHeight(null);

        if (this.getHeight() > maxHeight) {
            this.setHeight(maxHeight);
        }

        dom.scrollTop = scrollTop;
    },

    wasRecentlyVisible() {
        return SA.view.menu.MenuVisibilityTracker.wasRecentlyVisible(this);
    }
});

Ext.define('SA.view.RecentList.CustomLocationsList', {
    alias: 'widget.recent-custom-locations-list',
    extend: 'SA.view.RecentList',

    dataToItem(location) {
        var Locations = SA.data.LocationsCache,
            id = Locations.toLocationSeries(location),
            locationType = Locations.get(id).type;

        return {
            id,
            isCombination: locationType === 'combination',
            isRadius: locationType === 'radius',
            text: Ext.util.Format.locationRenderer(location)
        };
    },

    getAllData(source) {
        return source.getAll();
    },

    getMenuConfig(id) {
        return {
            defaults: {
                location: id
            },

            items: [
                {
                    xtype: 'menu-add-remove-favorite-location'
                }, {
                    xtype: 'menu-edit-combination-location'
                }, {
                    text: 'Delete',

                    handler() {
                        var location = this.location,
                            projects = [];

                        SA.data.Projects.all.forEach(project => {
                            if (project.containsLocation(location)) {
                                projects.push(project);
                            }
                        });

                        if (projects.length) {
                            Ext.widget({
                                xtype: 'delete-custom-location-window',
                                projects,

                                handler() {
                                    SA.data.CustomLocations.remove(location);
                                }
                            });
                        }
                        else {
                            SA.data.CustomLocations.remove(location);
                        }
                    }
                }
            ]
        };
    }
});

Ext.define('SA.view.RecentList.LocationsList', {
    alias: 'widget.recent-locations-list',
    extend: 'SA.view.RecentList',

    allowCustomLocationMenuItems: true,

    clearGeographicReleases() {
        this.geographicReleases = null;
        this.refresh();
    },

    dataToItem(location) {
        var source = this.source,
            Locations = SA.data.LocationsCache,
            id = Locations.toLocationSeries(location),
            locationType = Locations.get(id).type,
            unselectable = false;

        if (this.geographicReleases) {
            unselectable = !Locations.isLocationAvailableInGeographicReleases(id, this.geographicReleases);
        }

        if (this.censusRelease) {
            unselectable = unselectable || !Locations.locationAvailableInCensusRelease(id, this.censusRelease);
        }

        return {
            clicked: source.isClicked && source.isClicked(id),
            id,
            isCombination: locationType === 'combination',
            isRadius: locationType === 'radius',
            text: location && Ext.util.Format.locationRenderer(location) || '\u00a0',
            unselectable
        };
    },

    getAllData(source) {
        return SA.data.LocationsCache.get(source.getIds());
    },

    getItemHash(item) {
        return `${item.unselectable}:${item.text}`;
    },

    getMenuConfig(id) {
        var items = [
            {
                xtype: 'menu-add-remove-favorite-location'
            }, {
                xtype: 'menu-set-location-alias'
            }
        ];

        if (this.allowCustomLocationMenuItems) {
            items.push({xtype: 'menu-add-to-combination-location'});
            items.push({xtype: 'menu-edit-combination-location'});
            items.push({xtype: 'menu-create-radius-location'});
        }

        if (this.source === SA.data.RecentLocations) { 
            items.push({
                text: 'Remove from Recent List',

                handler() {
                    SA.data.RecentLocations.remove(this.location);
                }
            });
        }

        return {
            defaults: {
                location: id
            },

            items
        };
    },

    onItemClick(ev) {
        var el = ev.getTarget('.sa-recent-list-item'),
            isUnselectableLocation = ev.getTarget('.sa-recent-list-item-unselectable-location');

        if (isUnselectableLocation) {
            this.showUnselectableLocationMessageForItem(el);

            return;
        }

        this.callParent(arguments);
    },

    onItemMouseOver(ev) {
        var isUnselectableLocation = ev.getTarget('.sa-recent-list-item-unselectable-location');

        if (isUnselectableLocation) {
            return;
        }

        this.callParent(arguments);
    },

    setCensusRelease(censusRelease) {
        this.censusRelease = censusRelease;
        this.geographicReleases = null;
        this.refresh();
    },

    setGeographicReleases(geographicReleases) {
        this.geographicReleases = geographicReleases;
        this.refresh();
    },

    showUnselectableLocationMessageForItem(unselectableItem) {
        var me = this,
            censusRelease = this.censusRelease,
            id = unselectableItem.getAttribute("data-id"),
            Locations = SA.data.LocationsCache,
            country = SA.Institution.getCountry(SA.AppController.getCurrentProject().getCountry());

        if (this.unselectableLocationMessage) {
            if (this.unselectableLocationMessage.wasRecentlyVisible()) {
                return;
            }
            this.unselectableLocationMessage.destroy();
        }

        if (this.geographicReleases && !Locations.isLocationAvailableInGeographicReleases(id, this.geographicReleases)) {
            this.unselectableLocationMessage = createUnselectableLocationGeographicReleasesMessage(this);
        }
        else {
            this.unselectableLocationMessage = createUnselectableLocationCensusReleaseMessage(this);
        }

        this.unselectableLocationMessage.show();

        function createUnselectableLocationCensusReleaseMessage(target) {
            var lastYearInCensusRelease = censusRelease && country.getLastYearInCensusRelease(censusRelease);

            return Ext.widget({
                xtype: 'recent-list-unselectable-location-census-release-message',
                censusRelease,
                positionEl: unselectableItem,
                lastYearInCensusRelease,
                target,
                handler: () => me.hide()
            });
        }

        function createUnselectableLocationGeographicReleasesMessage(target) {
            return Ext.widget({
                xtype: 'recent-list-unselectable-location-geographic-release-message',
                positionEl: unselectableItem,
                target
            });
        }
    }
});

Ext.define('SA.view.RecentList.AttributesList', {
    alias: 'widget.recent-attributes-list',
    extend: 'SA.view.RecentList',

    dataToItem({attribute}) {
        return {
            id: attribute,
            text: SA.BadgedAttributeLabel.getHtml({attribute})
        };
    },

    getAllData(source) {
        return SA.data.AttributesCache.get(source.getIds());
    },

    getMenuConfig(id) {
        return {
            defaults: {
                attribute: id
            },

            items: [
                {
                    xtype: 'menu-add-remove-favorite-attribute'
                }, {
                    xtype: 'menu-view-attribute-metadata',

                    listeners: {
                        click: () => this.fireEvent('view-metadata:click')
                    }
                }, {
                    hidden: this.source !== SA.data.RecentAttributes, 
                    text: 'Remove from Recent List',

                    handler() {
                        SA.data.RecentAttributes.remove(this.attribute);
                    }
                }
            ]
        };
    }
});

Ext.define('SA.view.RecentList.BusinessesList', {
    alias: 'widget.recent-businesses-list',
    extend: 'SA.view.RecentList',

    cls: 'sa-recent-list-hide-item-button',

    dataToItem(search) {
        return {
            id: search.id,
            text: Ext.util.Format.htmlEncode(search.name)
        };
    },

    getAllData(source) {
        return source.getAll();
    },

    getMenuConfig() {
        return {
            items: [{
                text: 'Rename'
            }]
        };
    }
});
